const AbstractItemRepository = require('@/lib/Items/AbstractItemRepository');
const DataStoreNames = require('@/lib/DataStores/DataStoreNames');
const MembershipPlan = require('./MembershipPlan');

class MembershipPlanRepository extends AbstractItemRepository {
    /**
     * @param {DataStore} dataStore
     * @param {Hydrator} hydrator
     * @param {SyncStateManager} syncStateManager
     * @param {ItemBarcodeRepository} itemBarcodeRepository
     * @param membershipPlanResource
     */
    constructor(
        dataStore,
        hydrator,
        syncStateManager,
        itemBarcodeRepository,
        membershipPlanResource
    ) {
        super(dataStore, hydrator, syncStateManager, itemBarcodeRepository);

        this.membershipPlanResource = membershipPlanResource;
    }

    getEntityClass() {
        return MembershipPlan;
    }

    getEntityName() {
        return 'Membership Plan';
    }

    getTableName() {
        return DataStoreNames.MEMBERSHIP_PLANS;
    }

    getResource() {
        return this.membershipPlanResource;
    }
}

module.exports = MembershipPlanRepository;
